import { mapActions } from 'vuex';

export default {
  data() {
    return { deleteLoading: false };
  },
  methods: {
    ...mapActions([
      'deleteEntities',
    ]),
    showDeleteModal({ entities, redirect, model, mutation = '' }) {
      const { deleteMethod, closeModal } = this;
      const confirm = this.$confirm;
      const title = this.$t('general.deletePrompt');
      const okText = this.$t('general.yesDelete');
      const cancelText = this.$t('general.cancel');

      return () => {
        confirm({
          title,
          okText,
          okType: 'danger',
          cancelText,
          maskClosable: true,
          onOk() {
            deleteMethod({ entities, redirect, model, mutation });
            if (typeof closeModal !== 'undefined') {
              closeModal();
            }
          },
        });
      };
    },
    deleteMethod({ entities, redirect, model, mutation = '' }) {
      this.deleteLoading = true;
      const errorMessage = this.$t('error.default');
      const router = this.$router;
      return this.deleteEntities({
        entities,
        model,
        mutation,
      }).then((response) => {
        this.deleteLoading = false;
        if (response.status !== 200) {
          this.$showSnackbar({ color: 'error', message: errorMessage });
          return response;
        }

        if (redirect !== undefined && Object.keys(redirect).length > 0) {
          router.push(redirect);
        }
        return response;
      });
    },
  },
};
